<template>
  <div class="relative grid grid-cols-0 md:grid-cols-12 text-center">
    <div class="col-span-12 col-start-2 md:col-span-10 md:col-start-2">
      <p :class="brandService.getName() === Brand.HIS ? 'font-gotham-bold text-gray-700': 'text-gray-500'" class="max-w-prose mx-auto text-xl ">
        Confused? We're here for you - choose any help option below
      </p>
      <div class="mt-12">
        <div
          :class="brandService.getName() === Brand.HIS ? 'sm:grid-cols-1 lg:grid-cols-2 max-w-2xl mx-auto' : 'sm:grid-cols-2 lg:grid-cols-3'"
          class="grid grid-cols-1 gap-8 auto-cols-min items-center justify-center"
        >
          <div v-for="feature in features" :key="feature.name" class="pt-6">
            <div :class="brandService.getName() === Brand.HIS ? 'bg-white border border-gray-700 border-solid font-sans' : 'bg-gray-50'" class="flow-root rounded-lg px-8 pb-8 h-full">
              <div class="-mt-6">
                <div v-if="brandService.getName() === Brand.HIS">
                  <span class="inline-flex items-center justify-center p-4 bg-brand-button rounded-full">
                    <component :is="feature.icon" class="h-12 w-12 text-brand-primary" aria-hidden="true" />
                  </span>
                </div>
                <div v-else>
                  <span class="inline-flex items-center justify-center p-3 bg-brand-primary rounded-md shadow-lg">
                    <component :is="feature.icon" class="h-6 w-6 text-brand-button-text" aria-hidden="true" />
                  </span>
                </div>
                <h3
                  :class="brandService.getName() === Brand.HIS ? 'font-black text-xl' : 'font-medium text-lg'"
                  class="mt-8   text-gray-900 tracking-tight">{{ feature.name }}
                </h3>
                <div
                  :class="brandService.getName() === Brand.HIS ? 'text-xs text-gray-800' : 'xl:text-base text-xs text-gray-500'"
                  class="mt-5 " v-html="feature.description">
                </div >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, RenderFunction } from 'vue';
import {
  PhoneIcon,
  MailIcon,
  HomeIcon
} from '@heroicons/vue/outline';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

type Feature = {
  name: string,
  icon: string|RenderFunction,
  description: string
}

const props = defineProps<{
  features: Array<Feature>
}>();

props.features.forEach(feature => {
  if (feature.icon === 'MailIcon') {
    feature.icon = MailIcon;
  } else if (feature.icon === 'PhoneIcon') {
    feature.icon = PhoneIcon;
  } else if (feature.icon === 'HomeIcon') {
    feature.icon = HomeIcon;
  }
});

</script>
